import React, { FC } from 'react'

interface Props {
  label: string
  text?: string
  className?: string
}

const SummaryRow: FC<Props> = ({ label, text, className = '' }) => (
  <div className={`summary-row d-flex pb-2 pl-2 ${className}`}>
    <div className="summary-row-left pr-2">
      <span className="placeholder-text">{label}</span>
    </div>
    <div className="summary-row-right">
      <span>{text || '-'}</span>
    </div>
  </div>
)

export default SummaryRow
